import styled from 'styled-components'

import frontOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_front_outline.png'

export const WizzardPaginationBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 30vw;
  margin-top: 8vh;
  margin-bottom: 3vh;

  @media only screen and (max-width: 600px) {
    width: 90%;
    margin-top: 11vh;
    margin-bottom: 6vh;
  }
`

export const WizzardPaginationRange = styled.div`
  background-color: rgba(114, 143, 251, 0.18);
  width: 100%;
  height: 5px;
  position: relative;
  border-radius: 10px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${(props) => props.page * 14.2857142857 + 14.2857142857 + '%'};
    height: 5px;
    background-color: #a1ff68;
    border-radius: 10px;
  }
`

export const WizzardPageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.wizzard-training-info {
    width: 100%;
  }

  &.wizzard-photo-info {
    margin-top: 3%;
    align-self: baseline;
    width: 100%;
  }

  &.wizzard-photo-upload {
    /* max-height: 100%; */
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    input {
      display: none;
    }

    .custom-file-upload {
      z-index: 12;
      display: block;
      color: white;
      height: 75%;
      width: 100%;
      box-sizing: border-box;
      border-radius: 19px;
      /* padding: 10px 20px; */
      text-align: center;
      /* border: 1px solid white; */
      cursor: pointer;
      font-family: 'Nunito';

      @media only screen and (max-width: 600px) {
        width: 100%;
      }

      @media only screen and (min-width: 601px) {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      input {
        font-family: 'Nunito';
      }
    }
  }

  &.entry-mode {
    height: 100%;
    margin-top: 10px;
  }
`

export const ImageBox = styled.div`
  width: 100%;
  height: 80%;
  background-image: url(${frontOutline});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const WizzardVideo = styled.video`
  height: 100%;
  border-radius: 30px;
  /* max-width: 80vh; */
  width: 100%;

  @media only screen and (max-width: 600px) {
    height: 50vh;
    width: 125%;
    object-fit: cover;
  }
`

export const WizzardPhotoInfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 3% 0px;
`

export const WizzardTrainingDaysRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3% 0px;
  width: 100%;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`
